import { render, staticRenderFns } from "./PayrollDashboardFilter.vue?vue&type=template&id=70226b70"
import script from "./PayrollDashboardFilter.vue?vue&type=script&lang=js"
export * from "./PayrollDashboardFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports